import { Dialog2Service } from './dialog2.service';

export const providers = [Dialog2Service];
